import { _ } from '../utils.js'

import currencyNumber from '../utils/currency.js'
import Loading from '../modules/loading.js'
export default class Basket {
    constructor(el) {
        this.el = el
        this.form = _('form', 'element').nodeFrom(this.el)
        this.productItem = _('product-item', 'element').nodesFrom(this.el)
        this.quantities = _('quantity', 'element').nodesFrom(this.el)
        this.totalQuantity = _('total-quantity', 'element').nodeFrom(this.el)
        this.showTotalItems()
        this.showProductTotals()
    }

    showProductTotals = () => {
        this.productItem.map((item) => {
            const singlePrice = _('single-price', 'element')
                .nodeFrom(item)
                .innerHTML.replace(/[^.\d]/g, '')
            const quantity = _('quantity', 'element').nodeFrom(item).value
            const productTotalEl = _('product-total', 'element').nodeFrom(item)
            const productTotal = quantity * singlePrice

            productTotalEl.innerHTML = currencyNumber(productTotal)
        })
    }

    showTotalItems = () => {
        let totalItems = 0

        this.quantities.map((item) => {
            if (item.type === 'number') {
                totalItems += parseFloat(item.value)
            } else {
                const itemValue = item.innerHTML.replace('x', '')
                totalItems += parseFloat(itemValue)
            }
        })

        if (!totalItems) {
            return false
        }

        this.totalQuantity.innerHTML = `${totalItems} item${
            totalItems > 1 ? 's' : ''
        }`
    }

    showLoading = () => {
        this.resultsContainer.innerHTML =
            '<div class="loading" data-behaviour="loading"></div>'
        _('loading')
            .nodes()
            .map((el) => new Loading(el))
    }

    hideLoading = () => {
        this.resultsContainer.innerHTML = ''
    }
}
